import * as uuid from "uuid"
import * as httpx from "httpx"
import * as api from "brandguard/api"
import { UndoableAssetType } from "./undo"

type Item =
	| api.ImageSearchResponseItem
	| api.TextSearchResponseItem
	| api.DocumentSearchResponseItem
	| api.VideoSearchResponseItem

// awaitRequest returns an auto approved asset to awaiting a review request: no verdict and no queue.
// The server dismisses the approval log row the system wrote when it approved the asset, so the
// uploader needs no reviewer permission. The patched response omits a document's pages, so the
// item's own fields are kept beneath it.
export function awaitRequest(eventType: UndoableAssetType, item: Item, bearer: httpx.option): Promise<Item> {
	const event = { ...item.event!, observation: api.Prediction.NONE, queue: uuid.NIL }
	const keep = (r: { media?: unknown; event?: unknown }): Item => ({ ...item, ...r } as Item)
	switch (eventType) {
		case "image":
			return api.images.uploads.patch(event.brand_id, event.id, { ...item, event } as api.ImageSearchResponseItem, bearer).then(keep)
		case "text":
			return api.text.uploads.patch(event.id, event.brand_id, { ...item, event } as api.TextSearchResponseItem, bearer).then(keep)
		case "document":
			return api.documents.uploads.patch(event.brand_id, event.id, { ...item, event } as api.DocumentSearchResponseItem, bearer).then(keep)
		case "video":
			return api.videos.uploads.patch(event.brand_id, event.id, { ...item, event } as api.VideoSearchResponseItem, bearer).then(keep)
	}
}
